import {
	Card,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
	InputAdornment, SvgIcon,
	TextField, Divider
} from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import TableContainer from "@material-ui/core/TableContainer";
import React from 'react';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import Tooltip from '@material-ui/core/Tooltip'
import { Search as SearchIcon } from 'react-feather';
import Fuse from 'fuse.js'
import { useActions, useValues } from 'kea';

import grouplogic from 'src/store/group';

import AddDialog from './AddDialog';


const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});


const columns = [
	{
		field: 'name',
		headerName: 'Alert Name',
		align: 'left',
		width: 100,
	},
	{
		field: 'actions',
		align: 'right',
		headerName: 'Actions',
		width: 200,
	},
];


const options = {
	includeScore: false,
	keys: [
		'name',
	]
}

const Alerts = ({ alerts, selectedGroup }) => {
	const classes = useStyles();
	const [page, setPage] = React.useState(0);

	const { add_alerts, remove_alerts } = useActions(grouplogic);

	const [rowsPerPage, setRowsPerPage] = React.useState(5);
	let rows = selectedGroup.alerts;
	let emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

	const [searchField, setSearchField] = React.useState('');

	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	const handleRemove = (id) => {
		remove_alerts({
			_id: selectedGroup._id,
			alerts: [id]
		})
	}

	const handleAdd = (new_alerts) => {
		add_alerts({
			_id: selectedGroup._id,
			alerts: new_alerts
		})
	}

	if (searchField) {
		const fuse = new Fuse(rows, options);
		rows = fuse.search(searchField).map(item => {
			return item.item;
		})
		emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
	}

	return (
		<Card
			className={classes.root}
		>
			<div style={{
				display: 'flex',
				flexGrow: '1',
				justifyContent: 'space-between',
				alignItems: 'center',
				padding: '10px 15px 5px 15px'
			}}>
				<Typography variant="h4">
					Alerts
				</Typography>
				<TextField
					width={400}
					size={'small'}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<SvgIcon
									fontSize="small"
									color="action"
								>
									<SearchIcon />
								</SvgIcon>
							</InputAdornment>
						)
					}}
					onChange={e => setSearchField(e.target.value)}
					placeholder="Search ..."
					variant="outlined"
				/>
				<div style={{
					width: '70px',
					paddingLeft: '5px'
				}}>
					<AddDialog exclude={alerts} handleAdd={handleAdd} />
				</div>
			</div>
			<Divider />
			<div style={{ height: '100%', width: '100%', background: 'white' }}>
				<TableContainer className={classes.container}>
					<Table stickyHeader aria-label="sticky table" size={'small'}>
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<TableCell
										key={column.field}
										align={column.align}
										style={{ minWidth: column.width }}
									>
										{column.headerName}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{
								rows && rows.length > 0 ?
									rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row, index) => {
											return (
												<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
													{columns.map((column) => {
														if (column.field === 'actions') {
															return (
																<>
																	<TableCell key={`${row._id}-${column.field}`} align={column.align}>
																		<Tooltip title='Remove Alert'>
																			<IconButton aria-label="delete" onClick={() => handleRemove(row._id)}>
																				<RemoveIcon color="secondary" />
																			</IconButton>
																		</Tooltip>
																	</TableCell>
																</>
															)
														}
														const value = row[column.field];
														return (
															<TableCell key={`${row._id}-${column.field}`} align={column.align}>
																{column.format && typeof value === "number"
																	? column.format(value)
																	: value}
															</TableCell>
														);
													})}
												</TableRow>
											);
										})
									: <TableRow>
										<TableCell style={{ height: 61 * rowsPerPage }} colSpan={2} align={'center'}>
											No Alerts Assigned
										</TableCell>
									</TableRow>
							}
							{
								rows.length > 0 && emptyRows > 0 && (
									<TableRow style={{ height: 61 * emptyRows }}>
										<TableCell colSpan={6} />
									</TableRow>
								)
							}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={rows ? rows.length : 0}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
				{/* </Paper> */}
			</div>
		</Card>
	);
};


export default Alerts;
